import React, { useState } from 'react';
import './Education.css';

const Education = () => {
  const [activeTab, setActiveTab] = useState('western');

  return (
    <div className="education-tab-wrapper" id="education">
      <div className="education-tabs">
        <div
          className={`education-tab ${activeTab === 'western' ? 'active' : ''}`}
          onClick={() => setActiveTab('western')}
        >
          Western University
        </div>
        {/* Add more tabs here if needed */}
      </div>

      {activeTab === 'western' && (
        <div className="education-content">
          <h2 className="education-university">Western University</h2>
          <h3>London, Ontario</h3>
          <div className="education-degree">
            Bachelor of Engineering Science in Software Engineering<br />
            <small>September 2021 - April 2025</small>
          </div>
          <ul className="education-list">
            <li>Dean’s Honor List Recipient</li>
            <li>Varsity Tennis Team</li>
            {/* Add more bullet points or elaboration here */}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Education;

